<template>
    <div>
        <div class="ml-auto mb-3 text-right">
            <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                :data="exportData"
                :fields="exportFields"
                :header="exportHeaders"
                type="csv"
                :escapeCsv="false"
                :name="exportFileName">
                <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
        </div>
        <div class="row mb-3">
            <div class="col-sm-12 col-md-6 mb-2">
                <b-form-group :label="$t('label.filter_by_date')" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group class="mb-2"
                        id="dateFilterRadio"
                        v-model="selectedDateFilter"
                        :options="radDateFilter"
                        :aria-describedby="ariaDescribedby"
                        name="dateFilterRadio"
                    ></b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6" :class="selectedDateFilter != 'all' ? 'visible' : 'invisible'">
                <date-range-picker class="w-100 mb-2"
                    :minDate="minDate"
                    ref="picker"
                    v-model="dateRange"
                    :opens="'right'"
                    :autoApply="true"
                    :showDropdowns="true" 
                    :always-show-calendars="false"
                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                    @showCustomRange="showCustomRangeCalendars=true"
                    @update="filterByDate">
                </date-range-picker>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" >
                                <i class="fas fa-store"></i>
                            </label>
                            <multiselect :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" >
                                <i class="fas fa-user"></i>
                            </label>
                            <multiselect :value="selectedStaff" label="text" track-by="id" :options="staff" :searchable="true" :show-labels="false" openDirection="below" @select="filterByStaff">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
        <ul class="nav nav-tabs mt-2" role="tablist">
            <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.reportAttendanceType" :key="c.id">
                <a :class="{'active': selectedType == c.id}" class="nav-link" role="tab" @click="filterByType(c.id)">{{c.text}}</a>
            </li>
        </ul>
    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: "attendanceFilter",
    components:{
        DateRangePicker
    },
    data(){
        let now = moment();
        let startDate = now.startOf('day').toDate();
        let endDate = now.endOf('day').toDate()
        return{
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            tab: "summary",
            selectedDateFilter: "all", 
            outlet: [], selectedOutlet: {},
            staff: [], selectedStaff: {},
            selectedType: "all",
            dateRange: { startDate, endDate },
            exportHeaders: [], exportFields: {}, exportData: [], exportFileName: ""
        }
    },
    computed:{
        radDateFilter(){
            return this.$i18n.messages[this.$i18n.locale].salon_report.attendance.option_date_filter
        }
    },
    watch:{
        selectedDateFilter(value){
            if(value == "all"){
                this.filterAttendanceItem();
            }
        },
        "$i18n.locale"(val){
            this.staff[0].text = this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')})
            
            var b = Object.assign({}, this.selectedStaff)
            this.selectedStaff = this.staff.filter(obj=> obj.id == b.id)[0]
        }
    },
    methods:{
        clearFilter(){
            let now = moment();
            let startDate = now.startOf('day').toDate();
            let endDate = now.endOf('day').toDate()
            this.dateRange = {startDate, endDate}

            this.selectedDateFilter = this.selectedType = "all"
            this.selectedOutlet = this.outlet[0]
            this.selectedStaff = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')})}

            this.filterAttendanceItem();
        },
        filterByDate(date){
            var endDate = moment(date.endDate)
            var mEndDate = endDate.endOf('day').toDate()
            this.dateRange = {startDate: date.startDate, endDate: mEndDate}
            this.filterAttendanceItem();
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.selectedDateFilter = "all"
            this.selectedType = "all"
            this.selectedStaff = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')})}
            this.filterAttendanceItem();
        },
        filterByStaff(item){
            this.selectedStaff = item;
            this.filterAttendanceItem()
        },
        filterByType(type){
            this.selectedType = type
            this.filterAttendanceItem()
        },
        filterAttendanceItem(){
            var data = {
                dateType: this.selectedDateFilter,
                date: this.dateRange,
                type: this.selectedType,
                staffID: this.selectedStaff,
                outletID: this.selectedOutlet.id
            }
            this.$emit('filterAttendanceItem', data)
        },
        setExportData(data){
            this.exportData = data.data
            this.exportFields = data.fields
            this.exportHeaders = data.headers
            this.exportFileName = data.fileName
        },
        setStaffFilter(data, selectedStaff){
            this.staff = []
            this.staff = [{id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')})}]

            var staff = data.filter((o, i) =>
            data.findIndex(obj => obj.staffID == o.staffID) == i
            );
            
            for(var i=0; i<staff.length; i++){
                this.staff.push({
                    id: staff[i].staffID,
                    text: staff[i].name
                })
            }
            this.selectedStaff = selectedStaff
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0]
        $vm.selectedStaff = {id: 'all', text: $vm.$i18n.t('label.all', {'item': $vm.$i18n.t('subMenu.salon_setting_staff')})}
        $vm.filterAttendanceItem()
    }
}
</script>
<style scoped>
.link, .nav-link{
    cursor: pointer;
}
</style>